import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpParams,
    HttpHeaders
} from '@angular/common/http';
import { take, exhaustMap, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AuthService } from './auth.service';
import { AuthState } from './store/auth.reducer';
import { getAuthData } from './store/auth.selectors';
import { AuthData } from './auth-data.model';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(private _authState: Store<AuthState>) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {

        if (req.headers.get("No-Authorization")) {
            const modifiedReq = req.clone({
                headers: req.headers.delete("No-Authorization")
            });
            return next.handle(modifiedReq);;
        }

        let authData: AuthData;
        this._authState.select(getAuthData).pipe(
            take(1)
        ).subscribe(
            data => authData = data
        )

        if (authData && authData.token) {
            const modifiedReq = req.clone({
                headers: new HttpHeaders().set('Authorization', authData.token)
            });
            return next.handle(modifiedReq);
        }

        return next.handle(req);
    }
}